<template>
  <b-container>
    <b-row>
      <b-col>
        <p class="h5 mb-4" v-html="$t('html.tennessen')"></p>
        <BaseRadioInput v-model="tennessenAcceptance" 
                            :v="$v.tennessenAcceptance"
                            :label="$t('labels.tennessen')"
                            :options=yesNoOptions
                            slug="tennessenAcceptance"
                            :messages="acceptanceMessages"/>

      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <BaseRadioInput v-model="isAdult" 
                            :v="$v.isAdult"
                            :label="$t('labels.isAdult')"
                            :options=yesNoOptions
                            slug="isAdult"
                            :messages="adultMessages"/>

      </b-col>
    </b-row>

    <b-row v-show="false">    
      <b-col style="height:150px;">
        <strong>Please sign below indicating your acceptance of the above statement</strong>
        <VueSignaturePad id="signature" width="100%" height="100px" ref="signaturePad" :options="{ onBegin, onEnd }" />
        <div class="mt-1">
          <b-button variant="outline-primary" size="sm" @click="undo">Undo</b-button>
        </div>
      </b-col>
    </b-row>
    <b-modal id="missing-signature" size="sm" title="Missing Signature">
      Your signature is required to continue.<br/>
      Please use your finger, stylus or mouse to sign in the box.
    </b-modal>
  </b-container>
</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'

export default {
    mixins: [
       commonOptions
    ],
  data: () => ({
    tennessenAcceptance: null,
    isAdult: null,
    signature: null,
    acceptanceMessages: {
      checked: 'You must accept the Tennessen Statement above to continue with interview.'
    },
    adultMessages: {
      checked: 'You must assert that the subject of this interview is an adult.'
    },
  }),
  validations() {
    return {
      tennessenAcceptance: { checked: value => value === 'Y' || value === 'N' },
      isAdult: { checked: value => value === 'Y' || value === 'N' },
      signature: { required },
      form: [ 'tennessenAcceptance', 'isAdult', 'signature' ]
    }
  },
  watch: {
    tennessenAcceptance() {
    },
    isAdult() {
    }
  },
  methods: {
    validate() {
      
      this.save()
      if (!this.signature) {
        this.showMissingSignature()
      }

      if (this.tennessenAcceptance === 'N') {
          this.$emit('showInfoPage');
      }

      if (this.isAdult === 'N') {
          this.$emit('showInfoPage');
      }
      
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) { 
        //this.signature = null
        this.signature = "present"
      } else {
        this.signature = data
      }
    },
    onBegin() {
      this.$refs.signaturePad.resizeCanvas()
    },
    onEnd() {
    },
    showMissingSignature() {
      this.$bvModal.msgBoxOk('Your signature is required to continue. Please use your finger, stylus or mouse to sign in the box.', {
          title: 'Missing Signature',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
          .then(value => {
            // do nothing
          })
          .catch(err => {
            // An error occurred
          })
    }
  }
}
</script>

<style>

ol {
  display: block;
}

li {
  display: list-item;
  margin-bottom: .5rem;
}

#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #4bc5e8);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

</style>
